import { useRef, useEffect } from 'react';
import { BaseHttpClient } from '../clients/base-http-client';

interface IHttpServiceOptions {
    autoAbort?: boolean;
    errorHandler: ((err: { message: string }) => void) | null;
}

export function useHttpService<Type>(
    concreteService: { new (): Type; _errorHandler?: ((err: { message: string }) => void) | null },
    options: IHttpServiceOptions = { errorHandler: null, autoAbort: true },
): Type {
    const serviceRef = useRef(new concreteService());
    const { errorHandler, autoAbort } = options;

    const handleError = (err: { message: string }) => {
        if (errorHandler) return errorHandler(err);

        if (err.message == 'canceled') {
            return;
        }
    };

    (serviceRef.current as unknown as BaseHttpClient).setErrorHandler(handleError);

    useEffect(() => {
        return () => {
            const service = serviceRef.current as BaseHttpClient;
            if (service && service.abort && autoAbort) {
                service.abort();
            }
        };
    }, []);

    return serviceRef.current;
}
